// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`PaymentUpdateSubsModal general snapshot 1`] = `
<div class="payment-update-subs-modal">
  <sectiontitle-stub text="Update Payment Method" class="app-modal-title"></sectiontitle-stub>
  <p class="xs-f-small max-at-tweak">You've updated your default payment method. Would you like to use this payment method for all subscriptions?</p>
  <div class="row">
    <div class="row prod">
      <div class="xs-12 prod-info">
        <p class="upper bold">· Name 1</p>
        <pill-stub text="Extra Tube" class="ml-10 inline-block"></pill-stub>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="row prod">
      <div class="xs-12 prod-info">
        <p class="upper bold">· Name 2</p>
        <!---->
      </div>
    </div>
  </div>
  <submitbuttons-stub submittext="use this payment method" submitmethod="function () { [native code] }" submitvisible="true" submitclass="" canceltext="no, don't update my other subscriptions" cancelmethod="function () { [native code] }" cancelvisible="true" cancellink="true"></submitbuttons-stub>
</div>
`;
